<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2">CONTENTS</h2>
<p class="toc" id="map"><span href="#/text/9780062290953_Map" title="Link target outside of Sample">MAP</span></p>
<p class="toc" id="ded"><span href="#/text/9780062290953_Dedication" title="Link target outside of Sample">DEDICATION</span></p>
<p class="toc" id="ack"><span href="#/text/9780062290953_Acknowledgement#rack" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></p>
<p class="toc-1" id="pro"><a href="#/text/9780062290953_Prologue">PROLOGUE</a></p>
<p class="toc" id="ch01"><a href="#/text/9780062290953_Chapter_1">I • BIRTH PANGS</a></p>
<p class="toc" id="ch02"><span href="#/text/9780062290953_Chapter_2" title="Link target outside of Sample">II • A SHADOW ON THE MOON</span></p>
<p class="toc" id="ch03"><span href="#/text/9780062290953_Chapter_3" title="Link target outside of Sample">III • FIRST BLOOD</span></p>
<p class="toc" id="ch04"><span href="#/text/9780062290953_Chapter_4" title="Link target outside of Sample">IV • LADY OF THE EASTERN GATE</span></p>
<p class="toc" id="ch05"><span href="#/text/9780062290953_Chapter_5" title="Link target outside of Sample">V • THE FLOWER BRIDE</span></p>
<p class="toc" id="ch06"><span href="#/text/9780062290953_Chapter_6" title="Link target outside of Sample">VI • THE SACRED ROUND</span></p>
<p class="toc" id="ch07"><span href="#/text/9780062290953_Chapter_7" title="Link target outside of Sample">VII • THE WOUNDED KING</span></p>
<p class="toc" id="ch08"><span href="#/text/9780062290953_Chapter_8" title="Link target outside of Sample">VIII • THE GREAT QUEEN</span></p>
<p class="toc" id="ch09"><span href="#/text/9780062290953_Chapter_9" title="Link target outside of Sample">IX • A VESSEL OF LIGHT</span></p>
<p class="toc" id="ch10"><span href="#/text/9780062290953_Chapter_10" title="Link target outside of Sample">X • THE QUEST</span></p>
<p class="toc" id="ch11"><span href="#/text/9780062290953_People_and_Places" title="Link target outside of Sample">PEOPLE AND PLACES</span></p>
<p class="toc-1" id="ata"><span href="#/text/About_the_Author#rata" title="Link target outside of Sample">ABOUT THE AUTHOR</span></p>
<p class="toc" id="obb"><span href="#/text/9780062290953_Other_Books#robb" title="Link target outside of Sample">ALSO BY DIANA L. PAXSON</span></p>
<p class="toc" id="cop"><span href="#/text/9780062290953_Copyright#rcop" title="Link target outside of Sample">COPYRIGHT</span></p>
<p class="toc" id="atp"><span href="#/text/About_the_Publisher#ratp" title="Link target outside of Sample">ABOUT THE PUBLISHER</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062290953_Contents.vue?091d00a0